import { WHITE_COLORS } from "../constants";
export var getShadeBorder = function getShadeBorder(background, theme) {
  return WHITE_COLORS.includes(background) ? "1px solid ".concat(theme.palette.grey[200]) : undefined;
};
//# sourceMappingURL=getShadeBorder.js.map